import { Link } from "@tanstack/react-router";
import {
  useTheme,
  THEMES,
  DARK_BG,
  DARK_TEXT,
  LIGHT_BG,
  LIGHT_TEXT,
} from "../state/themeState.js";
import { BrandLogo } from "./BrandLogo.js";
import { NavMenu } from "./NavMenu.js";
import styles from "../styles/components/TopBar.module.css";

export function TopBar() {
  const { themeIndex, hoveredThemeIndex, isDark } = useTheme();
  const accentColor = THEMES[hoveredThemeIndex ?? themeIndex]?.[isDark ? "dark" : "light"].primary;

  return (
    <header className={styles.bar}>
      <Link to="/" className={styles.logoLink}>
        <BrandLogo
          accentColor={accentColor}
          textColor={isDark ? DARK_TEXT : LIGHT_TEXT}
          backgroundColor={isDark ? DARK_BG : LIGHT_BG}
        />
      </Link>
      <NavMenu />
    </header>
  );
}
